import React from "react";
import "./GameOver.css";

interface GameOverProps {
  score: number;
  handleRestart: () => void;
}

const gifs = [
  "gifs/pedropedropedro.gif",
  "gifs/thumbsup.gif",
  "gifs/penguin.gif",
  "gifs/vegeta.gif",
  "gifs/mimimi.webp",
  "gifs/chipichipi.gif",
  "gifs/dimitri.gif",
  "gifs/dancingkid.gif",
];

const getRandomGif = () => {
  const randomIndex = Math.floor(Math.random() * gifs.length);
  return gifs[randomIndex];
};

const GameOver: React.FC<GameOverProps> = ({ score, handleRestart }) => {
  const randomGif = getRandomGif();

  return (
    <div className="gameover-container">
      <div className="cool-background"></div>
      <div className="card">
        <h1 className="gameover">Game Over</h1>
        <img src={randomGif} alt="Funny GIF" className="funny-gif" />
        <p className="gameover">Your score: {score}</p>
        <div className="try-again" onClick={handleRestart}>
          Try again
        </div>
      </div>
    </div>
  );
};

export default GameOver;
